import { Page } from "@/components/lims";
import { useLocation } from "react-router-dom";
import { Lock, CheckCircle } from "@phosphor-icons/react";

const MODULES = {
  qms: {
    name: "Quality Management System",
    tagline: "Deviations, CAPA, audits & change control",
    features: [
      "Deviations & non-conformances",
      "CAPA (corrective & preventive action)",
      "Internal audits & findings",
      "Complaint handling",
      "Change control workflow",
      "Supplier qualification",
    ],
  },
  edms: {
    name: "Electronic Document Management",
    tagline: "Controlled documents, SOPs & training",
    features: [
      "Controlled document versioning",
      "SOP review & approval cycles",
      "Read-and-understood tracking",
      "Training curricula & competency",
      "Document distribution control",
      "Retention & archival policies",
    ],
  },
};

export default function ComingSoon() {
  const path = useLocation().pathname.replace("/", "");
  const mod = MODULES[path] || MODULES.qms;

  return (
    <Page>
      <div className="max-w-2xl mx-auto text-center py-16">
        <div className="w-16 h-16 rounded-2xl bg-slate-900 flex items-center justify-center mx-auto mb-6">
          <Lock size={30} weight="duotone" color="#fff" />
        </div>
        <span className="text-xs uppercase tracking-[0.25em] font-semibold text-slate-400">Module locked</span>
        <h1 className="text-3xl font-display font-semibold tracking-tight text-slate-900 mt-3">{mod.name}</h1>
        <p className="text-slate-500 mt-2">{mod.tagline}</p>
        <div className="inline-flex items-center gap-2 mt-6 px-4 py-2 rounded-full bg-status-warn/10 border border-status-warn/30 text-status-warn text-sm font-medium">
          Coming soon. Not enabled in this release.
        </div>

        <div className="mt-10 bg-white rounded-lg border border-slate-200 p-8 text-left">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-4">Planned capabilities</p>
          <div className="grid sm:grid-cols-2 gap-3">
            {mod.features.map((f) => (
              <div key={f} className="flex items-center gap-2.5 text-sm text-slate-600">
                <CheckCircle size={18} weight="duotone" className="text-slate-300 shrink-0" />
                {f}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Page>
  );
}
